<div class="container-fluid">
    
    <mat-divider class="mb-3"></mat-divider>
    <div class="row">
        <h3>Antecedentes Cónyuge / Conviviente </h3> 
    </div>
    <form [formGroup]="form" class="row" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>RUT</mat-label>
            <input matInput formControlName="rut" placeholder="XXXXXXXX-X">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" placeholder="Nombre">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Apellido Paterno</mat-label>
            <input matInput formControlName="apellidoPaterno" placeholder="Apellido Paterno">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Apellido Materno</mat-label>
            <input matInput formControlName="apellidoMaterno" placeholder="Apellido Materno">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Celular</mat-label>
            <input matInput formControlName="celular" placeholder="Ingrese 8 dígitos" (input)="onPhoneInput()">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-4">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Email" type="email">
        </mat-form-field>
    
        <mat-form-field class="col-md-3" appearance="outline">
            <mat-label>Nivel de Estudios</mat-label>
            <mat-select formControlName="nivelEstudios" (valueChange)="nivelEstudiosChange($event)">
              <mat-option *ngFor="let tipo of getTipoNivelEstudiosKeys()" [value]="tipo">{{ tiposNivelEstudios[tipo]
                }}</mat-option>
            </mat-select>
          </mat-form-field>
    
          <mat-form-field class="col-md-3" appearance="outline">
            <mat-label>Tipo Carrera</mat-label>
            <mat-select formControlName="tipoCarrera" (valueChange)="tipoCarreraChange($event)">
              <mat-option *ngFor="let tipo of getTipoCarreraKeys()" [value]="tipo">{{ tiposCarrera[tipo] }}</mat-option>
            </mat-select>
          </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Carrera</mat-label>
            <input matInput formControlName="carrera" placeholder="Carrera">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Año que Cursa</mat-label>
            <input matInput type="text" formControlName="anoCursa" placeholder="Año que Cursa">
        </mat-form-field>

        <mat-divider class="mb-3"></mat-divider>
        
        <div class="row">
            <h3>Ingresos Líquidos Mensuales</h3>
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>Sueldo</mat-label>
            <input matInput currencyMask type="text" formControlName="sueldo" placeholder="$" (keyup)="sumaIngresos()">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>Honorarios</mat-label>
            <input matInput currencyMask type="text" formControlName="honorarios" placeholder="$" (keyup)="sumaIngresos()">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>Retiros</mat-label>
            <input matInput currencyMask type="text" formControlName="retiros" placeholder="$" (keyup)="sumaIngresos()">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>Arriendos</mat-label>
            <input matInput currencyMask type="text" formControlName="arriendos" placeholder="$" (keyup)="sumaIngresos()">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>Otros</mat-label>
            <input matInput currencyMask type="text" formControlName="otros" placeholder="$" (keyup)="sumaIngresos()">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>Total Ingresos</mat-label>
            <input matInput currencyMask type="text" formControlName="totalIngresos" readonly placeholder="$">
        </mat-form-field>
        <div class="row">
            <div class="mt-4">
                <button id="antecedentesCSiguiente" type="submit" mat-raised-button color="primary" class="ml1 mr1 fr">Siguiente</button>
                <button id="antecedentesCVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
            </div>
        </div> 
    </form>
</div>

